import { EmptyData, NavMenuError } from 'shared/ui';
import { SectionMenu } from 'shared/ui/section-menu';
import { PUSH_NOTIFICATION_ROUTES } from 'shared/consts/routes/push-notification';

import { SECTION } from 'entities/navigation';
import { useGetPushNotificationMessagesQuery } from 'entities/push-notification';

import { AddButton } from './add-button';

const { label, path } = SECTION['push-notifications'];

export function ConnectedPushNotificationsMenu() {
  const { data, isFetching, error } = useGetPushNotificationMessagesQuery();

  if (data && data.statusCode !== 0) {
    return <NavMenuError text={data.statusDescription} />;
  }

  if (error) {
    return <NavMenuError />;
  }

  if (!isFetching && !data) {
    return <EmptyData />;
  }

  const items = data?.pushNotificationMessages || [];

  return (
    <SectionMenu
      loading={isFetching}
      items={items}
      menuKey={path}
      absolutePath={PUSH_NOTIFICATION_ROUTES.PUSH_NOTIFICATIONS}
      label={label}
      addButton={<AddButton />}
    />
  );
}
